
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'app-input',
  inheritAttrs: false,
})
export default class AppInput extends Vue {
  @Prop({ required: true, type: [String, Number] })
  readonly value!: string | number;

  @Prop({ required: false, type: String, default: 'text' })
  readonly type!: string;

  @Prop({ required: false, type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  readonly ignorePasswordManager!: boolean;

  isReadonlyLocked = false;

  mounted() {
    this.isReadonlyLocked = this.ignorePasswordManager;
  }

  get effectiveType(): string {
    if (this.ignorePasswordManager && this.type === 'text') {
      return 'search';
    }

    return this.type;
  }

  get inputClass(): Record<string, boolean> {
    return {
      'input-disabled': this.disabled,
      'ignore-password-manager-input': this.ignorePasswordManager,
    };
  }

  get inputAttrs(): Record<string, unknown> {
    if (!this.ignorePasswordManager) {
      return this.$attrs;
    }

    const { autocomplete, ...rest } = this.$attrs;

    return {
      ...rest,
      ...this.passwordManagerAttrs,
    };
  }

  get passwordManagerAttrs(): Record<string, string> {
    if (!this.ignorePasswordManager) {
      return {};
    }

    return {
      'autocomplete': 'off',
      'data-1p-ignore': '',
      'data-lpignore': 'true',
      'lpignore': 'true',
      'data-bwignore': '',
      'data-form-type': 'other',
    };
  }

  unlockForInput() {
    if (this.isReadonlyLocked) {
      this.isReadonlyLocked = false;
    }
  }
}
